import React from 'react';

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel = 'Confirm',
  onConfirm,
  onCancel,
  danger,
  busy = false,
}) {
  if (!open) return null;
  return (
    <div
      className="tt-modal-backdrop"
      onClick={busy ? undefined : onCancel}
    >
      <div
        className="tt-modal"
        style={{ maxWidth: 420, marginTop: '10vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '24px 24px 8px' }}>
          <h3 style={{ fontSize: 18, fontWeight: 700 }}>{title}</h3>
          <p
            style={{
              margin: '8px 0 0',
              color: 'var(--sp-fg-2)',
              fontSize: 14,
              lineHeight: '22px',
            }}
          >
            {body}
          </p>
        </div>
        <div
          style={{
            padding: 16,
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end',
          }}
        >
          <button
            className="btn btn-ghost"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            className={'btn ' + (danger ? 'btn-destructive' : 'btn-primary')}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy && (
              <span className="tt-spinner sm" style={{ marginRight: 6 }} />
            )}
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
